/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEnrichedInstrumentLinksRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetEnrichedInstrumentLinks.pb'
import {GetEnrichedInstrumentLinksResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetEnrichedInstrumentLinks.pb'


export const getEnrichedInstrumentLinks = (request: GetEnrichedInstrumentLinksRequest, options?: CashRequestOptions) => post<GetEnrichedInstrumentLinksRequest, GetEnrichedInstrumentLinksResponse>("/2.0/cash/get-enriched-instrument-links", request, {...options, rejectOnError: true })